const SHOW_ERROR = 'ts/ErrorDialog/SHOW_ERROR';
const CLOSE_ERROR = 'ts/ErrorDialog/CLOSE_ERROR';

export default {
  SHOW_ERROR,
  CLOSE_ERROR,
};
